/* @pareto-engineering/generator-front 1.0.12 */
import { createPortal } from 'react-dom';
import { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';

// Local Definitions
import { useTheme } from "../../../../a";
import "./styles.scss";
const baseClassName = styleNames.base;
const copyStyles = (sourceDocument, targetDocument) => {
  Array.from(sourceDocument.querySelectorAll('link[rel="stylesheet"], style')).forEach(link => {
    targetDocument.head.appendChild(link.cloneNode(true));
  });
};
/**
 * This is the component description.
 */
const NewWindowPortal = ({
  children,
  pageTitle,
  onBlock,
  onOpen
}) => {
  const [newWindow, setNewWindow] = useState(null);
  const container = useMemo(() => document.createElement('div'), []);
  const {
    userTheme = 'light'
  } = useTheme();
  useEffect(() => {
    if (!container) return;
    container.classList.add(baseClassName, 'new-window-portal', `ui-${userTheme}`);
    const newExternalWindow = window.open('', pageTitle, 'width="100%",height="100%"');
    if (newExternalWindow) {
      newExternalWindow.document.title = pageTitle;
      newExternalWindow.document.body.appendChild(container);
      setNewWindow(newExternalWindow);
      onOpen();
    } else {
      console.warn('A new window / tab could not be opened. Check your settings and/or extensions, maybe it was blocked.');
      onBlock();
    }

    // eslint-disable-next-line consistent-return
    return () => {
      container.classList.remove(...container.classList);
      newExternalWindow?.close();
    };
  }, [container, pageTitle, userTheme]);
  useEffect(() => {
    if (newWindow) {
      copyStyles(document, newWindow.document);
    }
  }, [newWindow]);
  return /*#__PURE__*/createPortal(children, container);
};
NewWindowPortal.propTypes = {
  /**
   *  The children JSX
   */
  children: PropTypes.node,
  /**
   * The new window page title
   */
  pageTitle: PropTypes.string.isRequired
};
NewWindowPortal.defaultProps = {
  // someProp:false
};
export default NewWindowPortal;